import {Group, Object3DEventMap, Vector3} from 'three'

/**
 * Returns all the reference points from the 3D scene
 */
export const getSceneReferencePoints = (scene: Group<Object3DEventMap>) => {
  const refs: {[key: string]: Vector3} = {}
  if (scene) {
    scene.traverse(child => {
      if (child.name.startsWith('ref_point_')) {
        refs[child.name] = child.position
      }
    })
  }
  return refs
}
